import { render, staticRenderFns } from "./AgentAccount.vue?vue&type=template&id=4922a468&scoped=true"
import script from "./AgentAccount.vue?vue&type=script&lang=js"
export * from "./AgentAccount.vue?vue&type=script&lang=js"
import style0 from "./AgentAccount.vue?vue&type=style&index=0&id=4922a468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4922a468",
  null
  
)

export default component.exports